<template>
  <div>
    <vx-card class="mb-1">
        <vs-row vs-type="flex" vs-justify="space-between" >
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="3">         
              <label class="vs-input--label mr-2">Nome</label>              
              <vs-input class="mb-4 w-full" v-model="filtro.nome" @keyup.enter="fetchLista(filtro)" />
          </vs-col>                              
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="9">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista(filtro)"></vs-button>
            <vs-button class="mr-2" color="dark" type="border" icon-pack="feather" icon="icon-file" @click="limparFiltros"></vs-button>  
            <vs-button class="mr-2" color="warning" type="filled" icon-pack="feather" icon="icon-plus" @click="routeNovoRegistro"></vs-button>          
            <vs-button color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-save" @click="exportarParaCSV" v-if="isGestor"></vs-button>          
          </vs-col>
      </vs-row>
    </vx-card>
     
    <h6 class="ml-2 mt-2 mb-2 text-danger"> {{dadosDaGrid.length }} registros </h6>
    <vx-card class="mb-1">
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :rowHeight="40"
        :headerHeight="20"        
        rowSelection="single"
        colResizeDefault="shift"
        @row-selected="onRowSelectedRegistro"    
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :paginationAutoPageSize="false"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>      
    </vx-card>
    
  </div>

</template>

<script>
import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

const URL_SERVLET = "/Produto/ListarProduto";
const NAME_ROUTE_EDIT = "cadastro-produtos-editar";

export default {
  components: {
    AgGridVue
  },
  data() {
    return {
      filtro : {nome: null},
      configuracaoGrid: { 
          gridApi: null, gridOptions: {}, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [            
            { headerName: 'CATEGORIA', field: 'categoria.nome', width: 75 },
            { headerName: 'NOME', field: 'nome', width: 75 },
            { headerName: 'Preço', field: 'precoCompra', width: 75 },
            { headerName: 'Qtd Atual', field: 'qtdAtual', width: 75 },            
          ]
      },
      dadosDaGrid: [],
      totalRegistros: 0      
    }
  },  
  created() {
      
  },
  computed: {
    isGestor() {
      return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
    }
  },
  methods: {
    limparFiltros() {
      this.filtro = {nome:  null};      
    },
    fetchLista(pFiltro) {     
      this.$vs.loading() 
      const params = new URLSearchParams();
      params.append('pagina', -1);
      
      if (pFiltro.nome) {
        params.append('nome', pFiltro.nome);
      }

      axios.post(URL_SERVLET, params, {   
              headers: {'Accept': 'application/json' },           
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/' });
          } else {
            this.totalRegistros = response.data.Resultado.quantidade;
            this.dadosDaGrid = response.data.Resultado.lista;                            
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
                        
    },
    routeNovoRegistro() {
      let self_ = this;

      self_.$router.push({
            name: NAME_ROUTE_EDIT                     
      })
    },
    onRowSelectedRegistro(evento) {
      let self_ = this;
      let registro = evento.node.data;
      
      self_.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: registro
            }
      })

    },
    exportarParaCSV() {
      var params = {columnSeparator: ';', fileName: 'Produtos.csv'};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    }
    
  },
  mounted() {
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api;
    this.configuracaoGrid.gridApi.sizeColumnsToFit();   
    if (this.$store.getters.filtroProduto) {
        this.filtro = JSON.parse(JSON.stringify(this.$store.getters.filtroProduto));
    }    
    this.fetchLista(this.filtro);
    
  },
  beforeDestroy() {    
    this.$store.dispatch('setarFiltro', {nomeTela: 'produto' , filtro: this.filtro});
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 310px);
  }
</style>
